import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { OrderReceiptResponse } from '@models/order';

import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function Etc({ receipt }:Props) {
  const {
    order, cardNo, cardName, pgTxId,
  } = receipt;
  const { orderNo, paymentAmount } = order;
  return (
        <Column fullWidth>
            <Column fullWidth>
                {/*
                <Row fullWidth justify='space-between'>
                    <Text>결제(컵보증금 포함)</Text>
                    <Text>7,000</Text>
                </Row>
                */}
                <Row fullWidth justify='space-between'>
                    <Text>주문번호</Text>
                    <Text>{orderNo}</Text>
                </Row>
            </Column>
            <ReceiptDivider/>
            {/*
            <Row fullWidth justify='space-between'>
                <Text>선불카드</Text>
                <Text>3,000</Text>
            </Row>
            */}
            {/*
            <ReceiptDivider/>
            <Row fullWidth justify='space-between'>
                <Text>선물쿠폰</Text>
                <Text>신규가입 쿠폰</Text>
            </Row>
            <ReceiptDivider/>
            */}
            <Column fullWidth spacing={2}>
                {/*
                <Row fullWidth justify='space-between'>
                    <Text>현금영수증 발급</Text>
                    <Text>173932424</Text>
                </Row>
                */}
                <Row fullWidth justify='space-between'>
                    <Text>카드종류</Text>
                    <Text>{cardName}</Text>
                </Row>
                <Row fullWidth justify='space-between'>
                    <Text>카드번호</Text>
                    <Text>{cardNo}</Text>
                </Row>
                <Row fullWidth justify='space-between'>
                    <Text>승인번호</Text>
                    <Text>{pgTxId}</Text>
                </Row>
            </Column>
        </Column>
  );
}

export default Etc;
